import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css'; // Import the CSS file

/**
 * HomePage component using CSS classes instead of styled-components
 */
const HomePage: React.FC = () => {
  return (
    <div className="container" role="main">
      <section className="section" aria-labelledby="hero-title">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
          <div style={{ maxWidth: '800px' }}></div>
          <p className="text-secondary" style={{ fontSize: '1.25rem', maxWidth: '600px', marginBottom: '1.5rem' }}>
            ConnectPath helps churches measure impact, enhance engagement, and implement
            strategic growth initiatives through comprehensive assessment tools.
          </p>
          <div style={{ display: 'flex', gap: '1rem', marginBottom: '3rem' }}>
            <Link
              to="/login"
              className="btn btn-primary btn-large"
              aria-label="Sign in to ConnectPath"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="btn btn-secondary btn-large"
              aria-label="Create a new account"
            >
              Create Account
            </Link>
          </div>
        </div>
      </section>
      
      <section className="section section-alt" aria-labelledby="features-title">
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}></div>
        <div className="grid grid-3" style={{ maxWidth: 'var(--container-xl)', margin: '0 auto' }}>
          <div className="card">
            <h3 id="feature-leadership">Leadership Assessment</h3>
            <p className="text-secondary" aria-labelledby="feature-leadership">
              Gain insights into your leadership team's effectiveness with
              customized assessment tools aligned with your church's vision.
            </p>
          </div>
          
          <div className="card">
            <h3 id="feature-engagement">Member Engagement</h3>
            <p className="text-secondary" aria-labelledby="feature-engagement">
              Track and improve member engagement through comprehensive
              metrics and early warning systems for disengagement.
            </p>
          </div>
          
          <div className="card">
            <h3 id="feature-ministry">Ministry Effectiveness</h3>
            <p className="text-secondary" aria-labelledby="feature-ministry">
              Measure the impact of your ministries with data-driven insights
              and benchmarking against similar churches.
            </p>
          </div>
          
          <div className="card">
            <h3 id="feature-planning">Strategic Planning</h3>
            <p className="text-secondary" aria-labelledby="feature-planning">
              Develop data-informed strategic plans with clear goals,
              milestones and resource allocation recommendations.
            </p>
          </div>
          
          <div className="card">
            <h3 id="feature-mobile">Mobile Engagement</h3>
            <p className="text-secondary" aria-labelledby="feature-mobile">
              Empower your leaders with the ConnectPath Engage mobile app
              for real-time alerts and member care coordination.
            </p>
          </div>
          
          <div className="card">
            <h3 id="feature-integration">Integration Capabilities</h3>
            <p className="text-secondary" aria-labelledby="feature-integration">
              Seamlessly connect with your existing church management system
              and communication platforms for unified data.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
